import { useI18n } from "../i18n";
import { LogoFull } from "./logo";

/** Rodapé — colunas de links sobre papel, wordmark vazado como assinatura. */
export function Footer() {
  const { t } = useI18n();

  const colunas = [
    {
      titulo: t("footer.h1"),
      links: [
        { label: t("nav.central"), href: "#produtos" },
        { label: "Boardyz", href: "#produtos" },
        { label: t("nav.servicos"), href: "#servicos" },
        { label: t("nav.processo"), href: "#processo" },
        { label: t("nav.seguranca"), href: "#seguranca" },
      ],
    },
    {
      titulo: t("footer.h2"),
      links: [
        { label: t("footer.results"), href: "#case" },
        { label: t("nav.faq"), href: "#faq" },
        { label: t("footer.contact"), href: "#contato" },
      ],
    },
    {
      titulo: t("footer.h3"),
      links: [
        { label: "contact@vortolabs.com", href: "mailto:contact@vortolabs.com" },
        { label: "LinkedIn", href: "#" },
        { label: "Instagram", href: "#" },
      ],
    },
  ];

  return (
    <footer className="relative overflow-hidden border-t border-line bg-surface">
      <div className="mx-auto max-w-6xl px-6 pt-16 pb-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          <div className="flex flex-col items-start gap-4">
            <a href="#topo" aria-label="Vorto" className="py-1">
              <LogoFull className="h-7 w-auto" />
            </a>
            <p className="max-w-56 text-sm leading-relaxed text-muted-foreground">
              {t("footer.sobre")}
            </p>
          </div>

          {colunas.map((col) => (
            <nav key={col.titulo} aria-label={col.titulo} className="flex flex-col gap-3">
              <h4 className="font-mono text-[11px] tracking-[0.16em] text-subtle uppercase">
                {col.titulo}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-accent"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-line pt-7 sm:flex-row">
          <p className="text-xs text-subtle">{t("footer.base")}</p>
          <p className="font-mono text-xs text-subtle">vortolabs.com</p>
        </div>
      </div>

      {/* assinatura: wordmark serifado vazado despontando no fim da página */}
      <div
        aria-hidden
        className="pointer-events-none -mb-[4vw] flex justify-center select-none"
      >
        <span
          className="font-display text-[20vw] leading-[0.78] font-semibold tracking-[-0.03em] text-transparent"
          style={{ WebkitTextStroke: "1px #dcd8cb" }}
        >
          VORTO
        </span>
      </div>
    </footer>
  );
}
